<div class="body" style="visibility: visible;">
    <!-- carregando tela -->
    <!-- style="visibility: hidden;" -->

    <div class="main-dados-editados">

        <div class="loading-shade" id="carregamento" *ngIf="isLoadingResults">
            <mat-spinner></mat-spinner>
        </div>

    </div>

</div>

<div class="body" *ngIf="sucesso">
    <!-- sucesso -->
    <!-- style="visibility: hidden;" -->

    <div class="main-dados-editados">

        <div class="div-titulo">
            <mat-icon style="color: blue;">check_circle</mat-icon>
            <p class="p-titulo">
                <strong>Sucesso</strong>
            </p>
        </div>

        <div class="div-body-sucesso">
            <p class="p-body-sucesso">
                Alteração feita com sucesso
            </p>
        </div>

        <div class="div-rodape">
            <button mat-raised-button color="primary" (click)="close()"> Ok </button>
        </div>

    </div>

</div>

<div class="body" *ngIf="!sucesso">
    <!-- erro -->
    <!-- style="visibility: hidden;" -->

    <div class="main-dados-editados">

        <div class="div-titulo">
            <mat-icon style="color: red;">error</mat-icon>
            <p class="p-titulo">
                <strong>Erro</strong>
            </p>
        </div>

        <div class="div-body-erro">
            <p class="p-body-erro">
                Não Foi Possível Salvar a Alteração.
            </p>
            <p class="p-body-erro">
                A Informação 'X' Está Incorreta
            </p>
            <p class="p-body-erro">
                Verifique Novamente!
            </p>
        </div>

        <div class="div-rodape">
            <button mat-raised-button color="primary" (click)="close()"> Ok </button>
        </div>

    </div>

</div>